import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { VillageDeviceAuthDto } from "./dtos/VillageDeviceAuthDto";
import { Typography } from "@mui/material";
import { dataGridSx } from "../../styles/bhpStyles";
import { useEffect, useState } from "react";
import { getUniqueItems } from "../../utils";


const columns: GridColDef[ ] = [ 

    {
        field: 'village',
        headerName: 'Village',
        width: 200,
    },

    {
        field: 'deviceCount',
        headerName: 'Total Device',
        width: 175,
    },

    {
        field: 'deviceAuthCount',
        headerName: 'Total Auth',
        width: 175,
    },

];


type VillageDeviceAuthStatsProps = {

    villageDeviceAuths: VillageDeviceAuthDto[ ];

};


export const VillageDeviceAuthStats: React.FC< VillageDeviceAuthStatsProps > = ( props: VillageDeviceAuthStatsProps ) => {

    const { villageDeviceAuths } = props;

    return(
        
        <>
        
            <Typography sx={{ marginTop: '30px', color: '#e65400', fontWeight: 'bold', fontSize: '25px' }}>Village Device</Typography>

            {

                villageDeviceAuths.length === 0 
                    ? 
                <Typography sx={{ marginTop: '15px' }}>No village device stats to display</Typography>
                    :
                <DataGrid
                    getRowId={ _ => Math.floor( Math.random( ) * 100_000_000 ) }
                    rows={ villageDeviceAuths }
                    columns={ columns }
                    autoHeight={ true }
                    sx={{ ...dataGridSx, width: 560, boxShadow: 5, marginTop: '5px !important' }}
                    sortingOrder={ [ 'desc', 'asc' ]}
                    disableSelectionOnClick
                    hideFooterPagination
                    hideFooterSelectedRowCount
                    hideFooter
                />

            }

        </>

    );

};